// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__TMCf4","return-link":"navigation_return-link__U-S-X"};